enum ApiVersion {
  V2 = 'api/v2',
}

export { ApiVersion };
